import { DateInput, FormInput, SwitchInput } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const translationPath = "page.4uDlist.listImportAutomation.";

export const BasicData = memo(() => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12} sm={12} textAlign="end">
        <SwitchInput name="enable" label={t(translationPath + "enable")} />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormInput
          size="small"
          name="name"
          fullWidth
          label={t(translationPath + "name")}
        />
      </Grid>

      <Grid item xs={6} sm={3}>
        <DateInput
          name="initialDate"
          label={t(translationPath + "initial_date")}
        />
      </Grid>

      <Grid item xs={6} sm={3}>
        <DateInput name="endDate" label={t(translationPath + "end_date")} />
      </Grid>

      <Grid item xs={12} sm={12}>
        <FormInput
          size="small"
          name="description"
          fullWidth
          multiline
          minRows={4}
          label={t(translationPath + "description")}
        />
      </Grid>
    </>
  );
});
